import React from "react";
import Contratos from "./Contratos";

export default function Honorarios(props) {
    return <Contratos {...props} isHonorariosTab={true} />;
}
